"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var react_1 = __importStar(require("react"));
var material_1 = require("@mui/material");
var Message_1 = __importDefault(require("./Message"));
var SendMessageBox_1 = __importDefault(require("./SendMessageBox"));
var useGetChatHeight_1 = __importDefault(require("../hooks/useGetChatHeight"));
var useIsSmallScreen_1 = __importDefault(require("../../hooks/useIsSmallScreen"));
var classes = {
    chatContainer: {
        border: function (theme) { return "1px solid ".concat(theme.palette.primary.main); },
        borderRadius: '5px',
        backgroundColor: 'white',
    },
    messagesContainer: {
        height: { xs: '100%', md: '500px' },
        overflowY: 'auto',
        padding: '10px',
    },
    messageContainerMobile: {
        height: '100%',
        overflowY: 'auto',
        padding: '10px',
        backgroundColor: 'white',
    },
};
function MessageList(_a) {
    var _b = _a.messages, messages = _b === void 0 ? [] : _b, chatId = _a.chatId;
    var _c = (0, react_1.useState)(false), visibleRef = _c[0], setVisibleRef = _c[1];
    var _d = (0, react_1.useState)(500), messageListHeight = _d[0], setMessageListHeight = _d[1];
    var messageContainerRef = (0, react_1.useRef)();
    var isSmallScreen = (0, useIsSmallScreen_1.default)();
    var calculatedHeight = (0, useGetChatHeight_1.default)();
    (0, react_1.useEffect)(function () {
        if (isSmallScreen === false) {
            setMessageListHeight(calculatedHeight);
        }
    }, [calculatedHeight, isSmallScreen]);
    (0, react_1.useEffect)(function () {
        if (!visibleRef || !messageContainerRef.current) {
            return;
        }
        messageContainerRef.current.scrollTop = messageContainerRef.current.scrollHeight;
    }, [visibleRef, messages, messageListHeight]);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(material_1.Box, __assign({ ref: function (element) {
                    messageContainerRef.current = element;
                    setVisibleRef(!!element);
                }, sx: isSmallScreen ? classes.messageContainerMobile : __assign(__assign({}, classes.messagesContainer), { height: "".concat(messageListHeight, "px") }) }, { children: messages.map(function (message) { return ((0, jsx_runtime_1.jsx)(Message_1.default, { message: message }, message.id)); }) })), chatId && (0, jsx_runtime_1.jsx)(SendMessageBox_1.default, { chatId: chatId })] }));
}
exports.default = MessageList;
